export default "__VITE_ASSET__DRD5HRrT__"